import { ArrowRightOutline18Icon } from "@vygruppen/spor-icon-react";
import {
  eventIsGlobalEvent,
  eventIsTrainEvent,
} from "features/History/utils/utils";
import { FC } from "react";
import { Link, generatePath } from "react-router-dom";
import { DropsButton, Text } from "shared/components/Spor";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { TRAIN } from "shared/utils/routes";
import { trimSwedishTrainNumber } from "shared/utils/trainNumberUtils";

export const TrainButton: FC<{ event: CombinedHistoryResponse }> = ({
  event,
}) => {
  let trainCountryCode: string | undefined;
  let trainIdentifier: string | undefined;
  let trainNominalDate: string | undefined;
  let trainLineNumber: string | undefined;

  if (eventIsTrainEvent(event)) {
    trainCountryCode = event.trainIdentifier.countryCode;
    trainIdentifier = event.trainIdentifier.identifier;
    trainNominalDate = event.trainIdentifier.nominalDate;
    trainLineNumber = event.lineNumber;
  } else if (eventIsGlobalEvent(event) && event.relatedEventDetails) {
    trainCountryCode = event.relatedEventDetails.trainIdentifier.countryCode;
    trainIdentifier = event.relatedEventDetails.trainIdentifier.identifier;
    trainNominalDate = event.relatedEventDetails.trainIdentifier.nominalDate;
    trainLineNumber = event.relatedEventDetails.lineNumber;
  }

  if (!trainIdentifier || !trainCountryCode || !trainNominalDate) {
    return <Text>-</Text>;
  }

  return (
    <Link
      to={generatePath(TRAIN, {
        countryCode: trainCountryCode,
        trainNumber: trainIdentifier,
        trainDate: trainNominalDate,
      })}
    >
      <DropsButton
        variant="tertiary"
        size="xs"
        rightIcon={<ArrowRightOutline18Icon />}
        marginTop="6px"
        onClick={(e) => e.stopPropagation()} // Necessary in order to make the link above work
      >
        <Text
          style={{
            whiteSpace: "nowrap",
            minWidth: "auto",
          }}
          variant="sm"
        >
          {trimSwedishTrainNumber(trainIdentifier)} / {trainLineNumber}
        </Text>
      </DropsButton>
    </Link>
  );
};
